module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      "sideBar": true, "fade-in": _vm.showToggleButton
    },
    on: {
      "mouseenter": _vm.openSideBar
    }
  }, [_c('i', {
    staticClass: "fa fa-bars primary-green-text left"
  })]), _vm._v(" "), _c('side-bar', {
    attrs: {
      "show": _vm.sideBarToggle,
      "type": _vm.sideBarType,
      "offerNames": _vm.filteredOffers,
      "sidebarHeader": _vm.sideBarTitle,
      "handleEvent": _vm.childEvent,
      "screenName": _vm.screenName
    },
    on: {
      "sidebarInactive": _vm.closeSideBar
    }
  }), _vm._v(" "), (_vm.headers) ? _c('div', {
    class: {
      'height-10': _vm.offerTypeFlag, 'height-12': !_vm.offerTypeFlag
    },
    style: ({
      'z-index': '1',
      'position': 'fixed',
      'background': 'white',
      'margin-left': '20px'
    })
  }, [_c('div', {}, [(_vm.pastOrPendingFlag === 'PAST') ? _c('div', {}, [_c('div', {
    style: ({
      'padding-top': '1rem',
      'margin-left': '1.5rem',
      'font-size': '1.5rem',
      'vertical-align': 'sub'
    })
  }, [_vm._v("Estimated figures are marked with\n          "), _c('span', {
    staticClass: "primary-green-text",
    style: ({
      'font-weight': 'bold'
    })
  }, [_vm._v("GREEN")]), _vm._v("\n          and Actual figures are marked with\n          "), _c('span', {
    staticClass: "black-text",
    style: ({
      'font-weight': 'bold'
    })
  }, [_vm._v("BLACK")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-block"
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_c('span', {
    style: ({
      'padding-left': '1.5rem',
      'font-size': '1.3rem'
    })
  }, [_vm._v("Offer Name: ")]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.2rem',
      'color': '#026937'
    })
  }, [_vm._v(_vm._s(_vm.offerName))]), _vm._v(" "), _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.gettersSelectedOffer.name))])]), _vm._v(" "), _c('div', {}, [_c('span', {
    style: ({
      'padding-left': '1.5rem',
      'font-size': '1.3rem'
    })
  }, [_vm._v("Campaign Period: ")]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.2rem',
      'color': '#026937'
    })
  }, [_vm._v(_vm._s(_vm.gettersAggInputData.period.name))])]), _vm._v(" "), _c('div', {}, [_c('span', {
    style: ({
      'padding-left': '1.5rem',
      'font-size': '1.3rem'
    })
  }, [_vm._v("Store: ")]), _vm._v(" "), _c('span', {
    style: ({
      'padding-left': '0.5rem',
      'font-size': '1.2rem',
      'color': '#026937'
    })
  }, [_vm._v(_vm._s(_vm.gettersAggInputData.storeLevel.name))])])]), _vm._v(" "), (_vm.detailedData && _vm.pastOrPendingFlag === 'PENDING') ? _c('div', {
    staticClass: "inline-block position-relative row",
    style: ({
      'float': 'right',
      'margin-top': '1rem'
    })
  }, [_c('button', {
    class: {
      'width_3': true, 'primary-green-bg': true
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openChartsVue
    }
  }, [(!_vm.buttonEnabled) ? _c('span', [_vm._v("Analytics")]) : _c('span', [_vm._v("Chart And Simulation")])]), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rejectOffer
    }
  }, [_vm._v("\n          Reject offer\n        ")]) : _vm._e(), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.approveWithChanges
    }
  }, [_vm._v("\n          Approve with changes\n        ")]) : _vm._e(), _vm._v(" "), (_vm.buttonEnabled) ? _c('button', {
    class: {
      'width_3': true, 'primary-green-bg': _vm.buttonEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showGoalsAndDisplay
    }
  }, [_vm._v("\n          Approve Offer\n        ")]) : _vm._e()]) : [(_vm.buttonEnabled) ? _c('button', {
    class: {
      'width_4': true, 'margin-left': true, 'primary-green-bg': _vm.buttonEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openChartsVue
    }
  }, [_vm._v("\n          Chart And Simulation\n        ")]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "position-relative scrollWrapper",
    style: ({
      'margin-left': (_vm.marginLeft + "px"),
      width: (_vm.scrollableWidth + "px"),
      'min-width': (_vm.tableContainerWidth + "px")
    }),
    attrs: {
      "id": "scrollWrapper"
    },
    on: {
      "scroll": _vm.topScrollContainer
    }
  }, [_c('div', {
    staticClass: "simulateScrollDiv",
    style: ({
      width: ((_vm.scrollableChildrenWidth * _vm.detailedData.length - (Math.floor(Number((_vm.detailedData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
    })
  })])]) : _vm._e(), _vm._v(" "), (_vm.headers !== null) ? _c('div', {
    staticClass: "outer-div-min",
    attrs: {
      "id": "outer-div-min"
    }
  }, [_c('div', {
    staticClass: "inner-div",
    class: {
      'padding-top-8': _vm.offerTypeFlag, 'padding-top-10': !_vm.offerTypeFlag
    },
    attrs: {
      "id": "offersComponentInnerDiv"
    }
  }, [_c('div', {
    staticClass: "inline-block margin-fix",
    attrs: {
      "id": "offersHeaderContainer"
    }
  }, [_c('vertical-header-table', {
    attrs: {
      "data": _vm.headers,
      "styles": _vm.tableStyles.headerTableStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block margin-fix",
    attrs: {
      "id": "offersSummaryContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.aggregatedData,
      "styles": _vm.tableStyles.summaryTableStyles,
      "stringPadding": _vm.aggregatedTablePadding
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-x inline-block margin-fix",
    style: ({
      width: (_vm.scrollableWidth + "px")
    }),
    attrs: {
      "id": "offersDetailsScrollableX"
    },
    on: {
      "scroll": _vm.bottomScrollContainer
    }
  }, [(_vm.detailedData !== null) ? _c('div', {
    staticClass: "table-container",
    style: ({
      width: ((_vm.scrollableChildrenWidth * _vm.detailedData.length - (Math.floor(Number((_vm.detailedData.length.toString()).replace(/.$/,"0")) / 2))) + "rem")
    })
  }, _vm._l((_vm.detailedData), function(data, i) {
    return _c('div', {
      staticClass: "inline-block margin-fix",
      style: ({
        width: (_vm.scrollableChildrenWidth + "rem")
      })
    }, [(_vm.pastOrPendingFlag === 'PENDING') ? _c('data-table', {
      attrs: {
        "data": data,
        "styles": _vm.tableStyles.detailsTableStyles,
        "stringPadding": _vm.detailedDataPadding,
        "functions": _vm.editPetDepotFunding
      }
    }) : (_vm.pastOrPendingFlag === 'PAST' && (i > 0 && i % 2 !== 0)) ? _c('data-table', {
      attrs: {
        "data": data,
        "styles": _vm.tableStyles.detailsTableStyles,
        "stringPadding": _vm.detailedDataPadding,
        "functions": _vm.editPetDepotFunding,
        "pendingOrPast": "PAST"
      }
    }) : (_vm.pastOrPendingFlag === 'PAST') ? _c('data-table', {
      attrs: {
        "data": data,
        "styles": _vm.tableStyles.detailsTableStyles,
        "stringPadding": _vm.detailedDataPadding,
        "functions": _vm.editPetDepotFunding,
        "pendingOrPast": "PENDING"
      }
    }) : _vm._e()], 1)
  })) : _vm._e()])])]) : _c('div', {
    staticClass: "preview"
  }, [_c('h2', {
    staticClass: "grey-text"
  }, [_vm._v(_vm._s(_vm.defaultNote))])]), _vm._v(" "), (_vm.popUp) ? _c('pop-up', {
    attrs: {
      "closePopUp": _vm.closePopUp,
      "type": _vm.popUpType,
      "styles": _vm.mainContainerStyle,
      "data": _vm.gettersGoalsAndDisplay.value
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70560836!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers-component/OffersComponent.vue
// module id = 374
// module chunks = 2